import React, { useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import { sectionPaddings, standardColours } from '../styles';
import PlanTabs from './PlanTabs';
import PlansTable from './PlansTable';

const StyledPlans = styled.section`
  ${sectionPaddings('30px', '80px')};
  background-color: ${standardColours.lightGrey};
`;

const Plans = ({ overline, heading, plansLink, state }) => {
  const {
    allDatoCmsPlan: { nodes: plans },
    allDatoCmsFeatureCategory: { nodes: featureCategories },
    allDatoCmsFeature,
  } = useStaticQuery(graphql`
    query PlansQuery {
      allDatoCmsPlan(sort: { position: ASC }, limit: 3) {
        nodes {
          name
          heading
          subheading
          ctaLink {
            text
            pageUrl {
              ...LinkFragment
            }
          }
          isMostPopular
        }
      }
      allDatoCmsFeatureCategory {
        nodes {
          id
          title
          slug
        }
      }
      allDatoCmsFeature(sort: { position: ASC }) {
        categories: group(field: { category: { title: SELECT } }) {
          fieldValue
          nodes {
            category {
              title
            }
            title
            plansFeatureTitleOverride
            plans {
              plan {
                name
              }
              textOverride
              includedInPlan
            }
            ...LinkFragment
          }
        }
      }
    }
  `);
  const [activeTabId, setActiveTabId] = useState(0);

  return (
    <StyledPlans id="plans">
      <PlanTabs
        overline={overline}
        heading={heading}
        plansLink={plansLink}
        plans={plans}
        featureCategories={featureCategories}
        features={allDatoCmsFeature}
        activeTabId={activeTabId}
        setActiveTabId={setActiveTabId}
      />
      <PlansTable
        overline={overline}
        heading={heading}
        plans={plans}
        featureCategories={featureCategories}
        features={allDatoCmsFeature}
        activePlan={state && state.plan}
      />
    </StyledPlans>
  );
};

export default Plans;
